import countdown from './countdown';
import stickyBar from './sticky-bar';

try {
  // safety loader
  if (!window.$) {
    window.$ = window.jQuery = require('jquery');

  }

  jQuery(document).ready(function($) {
    countdown();
    stickyBar();
  });
}
catch (e) {}